import { render, staticRenderFns } from "./ProfilesModule.vue?vue&type=template&id=f8f6eae8"
import script from "./ProfilesModule.vue?vue&type=script&lang=js"
export * from "./ProfilesModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports